// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1571":"737626a4","2138":"44a6cc9a","2282":"737626a4","2726":"ac714c75","3165":"daa1fd09","5527":"ac714c75","7250":"229019e0","8872":"4ba2d2f6"}[chunkId] + ".chunk.css";
};